import * as THREE from 'three';

// Loads what tools/build-seasons.mjs prepared for visualizers/seasons.js -
// the season photos aligned on summer, the masks, the four transition maps
// and the autumn leaves - once, at startup. Same preload/get shape as
// fountain-assets.js, and the same rule: the preload is a WIRING POINT every
// entry point must call (main, main-radio, main-embedded, play-boot,
// player-boot, the capture harness). Resolves to null when summer, winter,
// the masks or the maps are missing: the entry points then withdraw Seasons
// (disableVisualization). Without spring or autumn it resolves with the
// seasons it has and the visualizer plays a two-season year.
const MANIFEST_URL = 'textures/seasons.json';

let _assets = null;
let _promise = null;

function loadTexture(url, data) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, function (t) {
      // photos in sRGB; masks and maps are data (no colour space). Linear
      // filtering keeps the build's softened edges, and on the maps it
      // filters the two bytes of T together exactly.
      t.colorSpace = data ? THREE.NoColorSpace : THREE.SRGBColorSpace;
      t.generateMipmaps = false;
      t.minFilter = THREE.LinearFilter;
      t.magFilter = THREE.LinearFilter;
      t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
      t.needsUpdate = true;
      resolve(t);
    }, undefined, function () { reject(new Error(url + ' failed to load')); });
  });
}

export function preloadSeasons() {
  if (_promise) return _promise;
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('seasons.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (m) {
      const p = m.photos || {};
      if (!p.summer || !p.winter || !m.masks || !m.masks2 || !m.trans || m.trans.length !== 4) throw new Error('seasons.json incomplete (run tools/build-seasons.mjs)');
      const names = ['spring', 'summer', 'autumn', 'winter'].filter(function (s) { return p[s]; });
      const jobs = names.map(function (s) { return loadTexture('textures/' + p[s], false); });
      jobs.push(loadTexture('textures/' + m.masks, true), loadTexture('textures/' + m.masks2, true));
      for (const t of m.trans) jobs.push(loadTexture('textures/' + t, true));
      return Promise.all(jobs).then(function (tex) {
        const photos = {};
        names.forEach(function (s, i) { photos[s] = tex[i]; });
        const k = names.length;
        _assets = { manifest: m, seasons: names, photos: photos, masks: tex[k], masks2: tex[k + 1], trans: tex.slice(k + 2, k + 6), leaves: m.leaves || [] };
        return _assets;
      });
    })
    .catch(function (err) {
      console.error('[party-mode] seasons assets unavailable, Seasons will not be offered', err);
      _assets = null;
      return null;
    });
  return _promise;
}

export function getSeasons() {
  return _assets;
}
